"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  index: "P.01",
  title: "GT Securities, Inc. - FINRA/SIPC Member",
  description: "Securities transactions described on this website and conducted on behalf of BPV clients are effected through GT Securities, Inc. GT Securities, Inc. is a registered broker-dealer, Member FINRA and SIPC.\n•\xA0 \xA0 FINRA Member: Check the background of GT Securities, Inc. on FINRA's BrokerCheck at https://brokercheck.finra.org\n•\xA0 \xA0 SIPC Member: For information about SIPC coverage, visit https://www.sipc.org\n\n",
  linkLabel: "Review our privacy standards",
  image: {
    src: "https://bpvconsulting.com/wp-content/uploads/2026/06/GT-Securities-FINRA-SIPC-1.png?v=rx5ad49cyws",
    srcset: "https://bpvconsulting.com/wp-content/uploads/2026/06/GT-Securities-FINRA-SIPC-1.png?v=cqfxuk505nb",
    sizes: "https://bpvconsulting.com/wp-content/uploads/2026/06/GT-Securities-FINRA-SIPC-1.png?v=0p377sguvb9i",
    alt: "Secure digital data room interface for M&A documentation",
    label: "GT Securities"
  },
  imageRight: true
}, {
  index: "P.02",
  title: "Blue Phoenix Ventures - Nature of Business",
  description: "Blue Phoenix Ventures, LLC is an M&A advisory firm operating in association with GT Securities, Inc. BPV is not itself a registered broker-dealer. All securities-related advisory services - including sell-side M&A advisory, capital raises, and related financial advisory services that constitute broker-dealer activity under applicable law - are conducted exclusively through GT Securities, Inc. by GTS-registered personnel.\nBPV provides non-securities advisory services including strategic planning, business valuation analysis, and general management consulting independently of GT Securities.",
  linkLabel: "Explore valuation methodology",
  image: {
    src: "https://bpvconsulting.com/wp-content/uploads/2026/06/BPV-Nature-of-Business.png?v=mebmzsbuv4",
    srcset: "https://bpvconsulting.com/wp-content/uploads/2026/06/BPV-Nature-of-Business.png?v=89o2wu6q1a",
    sizes: "https://bpvconsulting.com/wp-content/uploads/2026/06/BPV-Nature-of-Business.png?v=bsh8dnjd6j5",
    alt: "Financial analytics dashboard showing valuation growth curves",
    label: "Blue Phoenix Ventures"
  },
  imageRight: false
}, {
  index: "P.03",
  title: "No Investment Advice",
  description: "Nothing on this website constitutes investment advice, a solicitation to buy or sell any security, or a recommendation of any specific transaction. The information provided is general in nature and does not take into account your individual financial situation, investment objectives, or risk tolerance. Consult qualified legal, tax, and financial advisors before entering into any transaction.",
  linkLabel: "View buyer network",
  image: {
    src: "https://bpvconsulting.com/wp-content/uploads/2026/06/No-Investment-Advice-e1781121482911.png?v=zinxr1921ap",
    srcset: "https://bpvconsulting.com/wp-content/uploads/2026/06/No-Investment-Advice-e1781121482911.png?v=5t0kikxdef6",
    sizes: "https://bpvconsulting.com/wp-content/uploads/2026/06/No-Investment-Advice-e1781121482911.png?v=j4vvclrh7us",
    alt: "Global network map showing strategic buyer connections",
    label: "No Investment Advice"
  },
  imageRight: true
}, {
  index: "P.04",
  title: "Past Performance",
  description: "Transaction case studies and representative engagements described on this website reflect past advisory activities. Past results are not indicative of future outcomes. M&A transactions and capital raises involve significant risk, and there is no guarantee that any specific result can be achieved.",
  linkLabel: "Review our privacy standards",
  image: {
    src: "https://bpvconsulting.com/wp-content/uploads/2026/06/Past-Performance-e1781121310737.png?v=i3g1eghppm",
    srcset: "https://bpvconsulting.com/wp-content/uploads/2026/06/Past-Performance-e1781121310737.png?v=7ogbeeisfuu",
    sizes: "https://bpvconsulting.com/wp-content/uploads/2026/06/Past-Performance-e1781121310737.png?v=dt51bivbyss",
    alt: "Secure digital data room interface for M&A documentation",
    label: "Past Performance"
  },
  imageRight: false
}, {
  index: "P.05",
  title: "California Regulatory Status",
  description: "Blue Phoenix Ventures, LLC is organized under the laws of the State of California. For inquiries regarding our regulatory status or to report a concern, please contact: Jeff@BPVConsulting.com.",
  linkLabel: "Email Blue Phoenix Ventures",
  image: {
    src: "https://bpvconsulting.com/wp-content/uploads/2026/06/Regulatory.png?v=mvtgjqdi9j",
    srcset: "https://bpvconsulting.com/wp-content/uploads/2026/06/California-Outline-and-Flag-Solid-e1781119457281-1.png?v=k6tcf4l0zgj",
    sizes: "https://bpvconsulting.com/wp-content/uploads/2026/06/California-Outline-and-Flag-Solid-e1781119457281-1.png?v=en6i8ngy0n9",
    alt: "Official seal representing California state regulatory compliance",
    label: "REGULATORY / CA-STATE"
  },
  imageRight: true
}, {
  index: "",
  title: "BrokerCheck",
  description: "In accordance with FINRA Rule 2210, we provide the following link: Check the background of this firm and its investment professionals on FINRA's BrokerCheck at https://brokercheck.finra.org. We encourage all clients and prospective clients to use BrokerCheck to verify the registration status and background of any investment professional.",
  linkLabel: "Visit BrokerCheck",
  image: {
    src: "https://bpvconsulting.com/wp-content/uploads/2026/06/BrokerCheck.png?v=03m8lwu9qfby",
    srcset: "https://bpvconsulting.com/wp-content/uploads/2026/06/BrokerCheck.png?v=1ldz1zhyzuc",
    sizes: "https://bpvconsulting.com/wp-content/uploads/2026/06/BrokerCheck.png?v=cf6x7fvs5ou",
    alt: "BrokerCheck logo",
    label: "BROKERCHECK"
  },
  imageRight: false
}];
function CornerTicks() {
  return <>
      <span className="pointer-events-none absolute -top-px -left-px h-2.5 w-2.5 border-t border-l border-[var(--primary)]" aria-hidden="true" />
      <span className="pointer-events-none absolute -top-px -right-px h-2.5 w-2.5 border-t border-r border-[var(--primary)]" aria-hidden="true" />
      <span className="pointer-events-none absolute -bottom-px -left-px h-2.5 w-2.5 border-b border-l border-[var(--primary)]" aria-hidden="true" />
      <span className="pointer-events-none absolute -bottom-px -right-px h-2.5 w-2.5 border-b border-r border-[var(--primary)]" aria-hidden="true" />
    </>;
}
function VioletBeam({
  className = ""
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-2 ${className}`} aria-hidden="true">
      <div className="h-px flex-1 bg-border" />
      <div className="h-1.5 w-1.5 rounded-md bg-[var(--primary)]" />
    </div>;
}
export default function Regulatorydisclosures() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1888" id="regulatorydisclosures" className="relative bg-background text-foreground py-28 md:py-36 overflow-hidden">
      <div ref={header.ref} className={`relative mx-auto max-w-[880px] px-5 md:px-8 text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      </div>

      <div className="relative mx-auto max-w-[1320px] px-5 md:px-8 mt-20 md:mt-28">
        {features.map((feature, i) => {
        const row = useRevealOnScroll<HTMLDivElement>({
          threshold: 0.15
        });
        const imageOnRight = feature.imageRight;
        return <div key={i} data-index={i}>
              <div ref={row.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center transition-all duration-700 ease-out ${row.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                <div className={`lg:col-span-7 ${imageOnRight ? "lg:order-1" : "lg:order-2"}`}>
                  <p className="font-mono text-xs uppercase tracking-[0.12em] text-[var(--primary)] mb-4">
                    {feature.index}
                  </p>
                  <h3 className="font-default font-medium text-[clamp(1.5rem,2vw,2rem)] leading-[1.15] tracking-tight mb-5">
                    {feature.title}
                  </h3>
                  <p className="font-default text-[clamp(1.0625rem,1.25vw,1.25rem)] leading-[1.6] text-muted-foreground max-w-xl mb-8">
                    {feature.description}
                  </p>
                  <Link to={feature.title === "BrokerCheck" ? "https://brokercheck.finra.org" : i === 4 ? "mailto:Jeff@BPVConsulting.com" : "#"} className="group inline-flex items-center gap-2 text-foreground hover:text-[var(--primary)] transition-colors duration-200">
                    <span className="font-default font-medium text-sm md:text-base">
                      {feature.linkLabel}
                    </span>
                    <ArrowRight className="size-4 text-[var(--primary)] transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
                  </Link>
                </div>

                <div className={`lg:col-span-5 relative ${imageOnRight ? "lg:order-2" : "lg:order-1"}`}>
                  <div aria-hidden="true" className={`pointer-events-none absolute -z-10 h-[420px] w-[420px] rounded-lg blur-3xl opacity-50 md:opacity-100 ${imageOnRight ? "-bottom-20 -left-20" : "-bottom-20 -right-20"}`} style={{
                background: "radial-gradient(closest-side, hsl(43 48% 59% / 0.35), transparent 70%)"
              }} />

                  <div className="group relative">
                    <div className={`relative ${i === 0 || i === 1 || i === 4 || i === 5 ? "aspect-auto" : "aspect-[4/3] overflow-hidden"} rounded-lg shadow-lg`}>
                      <img src={feature.image.src} data-wvc-srcset={feature.image.srcset} data-wvc-sizes={feature.image.sizes} alt={feature.image.alt} className={`h-full w-full ${i === 0 || i === 1 || i === 4 || i === 5 ? "object-contain" : "object-cover"} transition-transform duration-500 group-hover:scale-105`} loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                      <div className="absolute bottom-4 left-4 right-4 translate-y-2 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                        <p className="font-mono text-[10px] text-white tracking-widest uppercase">
                          {feature.image.label}
                        </p>
                      </div>
                      <CornerTicks />
                    </div>
                  </div>
                </div>
              </div>

              {i < features.length - 1 && <VioletBeam className="my-16 md:my-24" />}
            </div>;
      })}
      </div>
    </section>;
}